var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Thay đổi trường",
            visible: _vm.dialogVisible,
            width: "1000px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "5vh",
            "custom-class": "change-school-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "change-school-content" }, [
            _c("div", { staticClass: "school-panel" }, [
              _c("div", { staticClass: "school-panel-head" }, [
                _c("div", { staticClass: "panel-icon" }, [
                  _c("i", { staticClass: "el-icon-office-building" }),
                ]),
                _c("div", { staticClass: "panel-text" }, [
                  _c("p", { staticClass: "panel-title" }, [
                    _vm._v("Chọn trường làm việc"),
                  ]),
                  _c("p", { staticClass: "panel-subtitle" }, [
                    _vm._v(
                      "Chọn một trường trong danh sách bên dưới để chuyển phiên làm việc hiện tại."
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "school-table-wrapper" },
                [
                  _c(
                    "div",
                    { staticClass: "school-filter-bar" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Tìm trường theo tên hoặc mã",
                          clearable: "",
                          "prefix-icon": "el-icon-search",
                        },
                        on: { clear: _vm.onFilterClear },
                        model: {
                          value: _vm.filterText,
                          callback: function ($$v) {
                            _vm.filterText = $$v
                          },
                          expression: "filterText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "multipleTable",
                      staticClass: "school-table",
                      attrs: {
                        "empty-text": _vm.textTable,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        data: _vm.displayedList,
                        "row-class-name": _vm.rowClassName,
                        "highlight-current-row": "",
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeightSmallMini,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "fullName",
                          label: "Họ tên",
                          "min-width": "170",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "phone",
                          align: "center",
                          label: "Số điện thoại",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "school.id",
                          align: "center",
                          label: "Code",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "school.schoolName",
                          label: "Tên trường",
                          "min-width": "240",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "school-name-cell" }, [
                                  _c(
                                    "div",
                                    { staticClass: "school-name-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "school-name" },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.school.schoolName)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          width: "160",
                          align: "center",
                          label: "Lựa chọn",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "select-button",
                                    attrs: {
                                      type:
                                        scope.row.school &&
                                        scope.row.school.status
                                          ? "primary"
                                          : "default",
                                      plain:
                                        !scope.row.school ||
                                        !scope.row.school.status,
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeSchoolMethod(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          scope.row.school &&
                                            scope.row.school.status
                                            ? "Đã chọn"
                                            : "Chọn"
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer change-school-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-save",
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("button.save")))]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }